export default "__VITE_ASSET__498cb843__"